import {
  Modal,
  ButtonLink,
  ButtonsGroup,
} from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";

import { getSignInUrl, getSignUpUrl } from "../../../helpers/routingHelpers";
import {ASSETS_BUILD_PATH} from "../../../constants/staticUrls"
import { useModal } from "../hooks";
import { AUTH_INTERRUPT_MODAL_QUERY_PARAM } from "../constants";
import styles from "./AuthInterruptModal.module.scss";

const AuthInterruptModal = () => {
  const { isOpen, closeModal } = useModal(AUTH_INTERRUPT_MODAL_QUERY_PARAM);
  return (
    <Modal className="reset" isOpen={isOpen} handleClose={closeModal}>
      <Modal.Content>
        <img
          className={styles.authModalImage}
          src={`${ASSETS_BUILD_PATH}/img/auth_modal/auth-hime.png`}
          srcSet={`${ASSETS_BUILD_PATH}/img/auth_modal/auth-hime@2x.png 2x`}
          alt={<FormattedMessage id="alt.hime" />}
        />
        <Modal.Body>
          <Modal.Header>
            <FormattedMessage id="auth_modal.title" />
          </Modal.Header>
          <Modal.Text>
            <FormattedMessage id="auth_modal.description" />
          </Modal.Text>
        </Modal.Body>
        <Modal.ButtonsGroup>
          <ButtonsGroup>
            <ButtonLink to={getSignInUrl()}>
              <FormattedMessage id="auth_modal.login_button" />
            </ButtonLink>
            <ButtonLink to={getSignUpUrl()}>
              <FormattedMessage id="auth_modal.create_account_button" />
            </ButtonLink>
          </ButtonsGroup>
        </Modal.ButtonsGroup>
      </Modal.Content>
    </Modal>
  );
};

export default AuthInterruptModal;
